import React from 'react';
import { Stack } from '@mui/material';
import {
  AuthHelpRestoreLayout,
  InstructionSetup,
  InstructionSteps,
  StageHeader,
} from './AuthHelpRestoreLayout';

interface Props {
  provider: string;
  idPrefix?: string;
  showSetup?: boolean;
}

const stages = ['Войдите на втором устройстве'];

export const AuthHelpSameAccountItemDiv = ({
  provider,
  idPrefix = 'same-account-stage',
  showSetup = false,
}: Props) => (
  <AuthHelpRestoreLayout
    stages={stages}
    idPrefix={idPrefix}
    intro="Выполните эти шаги на устройстве, где ещё нет подписки."
  >
    <Stack
      component="section"
      id={`${idPrefix}-1`}
      spacing={2.5}
      sx={{ scrollMarginTop: 24 }}
    >
      <StageHeader
        stage={1}
        totalStages={stages.length}
        title={stages[0]}
        secondDevice
      />
      {showSetup && <InstructionSetup />}
      <InstructionSteps
        steps={[
          {
            id: 'same-provider',
            text: (
              <>
                Войдите в <strong>Учи Мед</strong> на втором устройстве через{' '}
                <strong>тот же {provider}</strong>, что и на устройстве с
                подпиской.
              </>
            ),
          },
          {
            id: 'same-subscriptions',
            text: (
              <>
                Проверьте вкладку <strong>«Мои подписки»</strong>.
              </>
            ),
          },
        ]}
      />
    </Stack>
  </AuthHelpRestoreLayout>
);

AuthHelpSameAccountItemDiv.defaultProps = {
  idPrefix: 'same-account-stage',
  showSetup: false,
};
